import React, {useEffect, useState} from 'react';
import _ from "lodash";
import ShowProgressSpinner from "../../../common/ui/show-progress-spinner";
import ShowEmptyListMessage from "../../../design/components/common/show-empty-list-message";

import {setDataInLocalStorage, getDataFromLocalStorage} from "../../../common/utils/local-storage-util";
import {getAllTags} from "../../../common/services/tag-data-service";
import {updateSinglePinterestPinSync} from "../../services/pinterest-pin-sync-data.service";
import {getAllDesignInfo} from "../../../shopify/services/design-info-data.service";
import {
    DESIGN_INFO_FILTER_FOR_SELECT_IMAGES_FIELDS,
    DESIGN_INFO_IDS,
    DESIGN_INFO_KEYS
} from "../../../shopify/constants/design-info.constant";
import {getCurrentPinterestPinSyncByType} from "../../utils/pinterest-sync-util";
import ParentProductDetail from "../../../pod/components/parent-product/edit-parent-product/parent-product-detail";
import DesignInfoFilters from "../../../shopify/components/design-info/design-info-filters";
import {getSingleParentProductById, searchParentProducts} from "../../../pod/services/parent-product-data-service";
import {
    searchPinterestImagesWithSearchCriteria,
    updateSinglePinterestImage
} from "../../services/pinterest-image-data.service";
import AddEditPinterestImages from "../../../marketing/components/media-editor/add-edit-pinterest-images";
import ProductImageSmall from "../../../pod/components/product-upload/product-image-small";
import {getImageDownloadUrlFromFullPath} from "../../../common/utils/image-util";
import {getSingleDesignById} from "../../../design/services/design-data-service";
import {generatePinterestPinsForDesign, prepareSingleDesignPinterestPinsList} from "../../utils/pinterest-pin-util";
import ExportBulkPinterestPins from "../pinterest-pin-sync/export-bulk-pinterest-pins";
import {getPinterestBoardForParentProduct} from "../../services/pinterest-board-data.service";
import {
    createPinterestBoardAndSections, createPinterestPins,
    createPinterestSections,
} from "../../services/pinterest-api-service";
import {CheckCircleIcon} from "@heroicons/react/24/solid";
import {PlusCircleIcon} from "@heroicons/react/24/outline";


const defaultFilterCriteria: any = {};

const DesignInfoList = ({pinterestAccount}) => {
    const [initialStep, setInitialStep] = useState(true);
    const [allDesignInfo, setAllDesignInfo] = useState(null);
    const [designList, setDesignList] = useState(null);
    const [filteredDesignList, setFilteredDesignList] = useState(null);
    const [filterCriteria, setFilterCriteria] = useState(defaultFilterCriteria);
    const [dataFetchInProgress, setDataFetchInProgress] = useState(true);
    const [allTags, setAllTags] = useState([]);
    const [selectedDesignInfo, setSelectedDesignInfo] = useState(null);
    const [syncUpdateInProgress, setSyncUpdateInProgress] = useState(false);
    const [pinterestImages, setPinterestImages] = useState([]);
    const [designDetail, setDesignDetail] = useState(null);
    const [pinterestPinSync, setPinterestPinSync] = useState(null);
    const [pinterestBoard, setPinterestBoard] = useState(null);
    const [pinterestBoardsByProductIdMap, setPinterestBoardsByProductIdMap] = useState({});

    useEffect(() => {
        if (initialStep) {
            setInitialStep(false);
            getAllDesignsDesignInfo();
            getCurrentPinterestPinSync();
        }
    }, [initialStep]);

    const getAllDesignsDesignInfo = async () => {
        setDataFetchInProgress(true);
        const allDesignInfoList = await getAllDesignInfo();
        const allDesignsDesignInfo = _.find(allDesignInfoList, {id: DESIGN_INFO_IDS.ALL_DESIGNS});
        const designInfoList = _.filter(allDesignInfoList, (designInfo) => designInfo?.id !== DESIGN_INFO_IDS.ALL_DESIGNS);

        setAllDesignInfo(allDesignsDesignInfo);

        const allDesigns = _.orderBy(designInfoList, ['productType', 'category', 'name'], ['asc', 'asc', 'asc']);

        setDesignList(allDesigns);
        setFilteredDesignList(allDesigns);

        setSelectedDesignInfo(allDesigns[0]);
        setDataFetchInProgress(false);

        const existingFilters = getDataFromLocalStorage(DESIGN_INFO_KEYS.DESIGN_INFO_FILTERS);
        setFilterCriteria(existingFilters || defaultFilterCriteria);
    }

    useEffect(() => {
        if (!_.isEmpty(designList)) {
            applyFilters();
            setDataInLocalStorage(DESIGN_INFO_KEYS.DESIGN_INFO_FILTERS, filterCriteria);
        }
    }, [filterCriteria]);

    const applyFilters = () => {
        let filteredList = [...designList];
        let existingFilterCriteria = {...filterCriteria};
        const filters = {};

        _.forEach(existingFilterCriteria, (filterValue, filterKey) => {
            if (filterValue) {
                if (filterValue === 'Yes') {
                    filters[filterKey] = true;
                } else if (filterValue === 'No') {
                    filters[filterKey] = false;
                } else {
                    filters[filterKey] = filterValue;
                }
            }
        });

        filteredList = _.filter(filteredList, filters);
        setFilteredDesignList(filteredList);
        setSelectedDesignInfo(filteredList[0]);
    }

    const refreshDesignInfoList = async () => {
        await getAllDesignsDesignInfo();
    }

    const addToPinterestPinSync = async (currentPinterestImage) => {
        setSyncUpdateInProgress(true);

        const currentDesignDetail = {...designDetail};
        const currentPinterestPinSync = {...pinterestPinSync};
        // const currentPinterestPinSync = await getCurrentPinterestPinSyncByType('PINTEREST');

        generatePinterestPinsForDesign(currentDesignDetail, currentPinterestImage, currentPinterestPinSync);
        currentPinterestPinSync.total = _.keys(currentPinterestPinSync.designs).length;
        currentPinterestPinSync.totalVariants = _.sumBy(_.values(currentPinterestPinSync.designs), 'totalVariants');

        await updateSinglePinterestPinSync(currentPinterestPinSync);
        setPinterestPinSync(currentPinterestPinSync);

        currentPinterestImage.added = true;
        await updateSinglePinterestImage(currentPinterestImage);

        setSyncUpdateInProgress(false);
    }

    useEffect(() => {
        if (selectedDesignInfo) {
            getPinterestImages(selectedDesignInfo);
            getDesignDetail(selectedDesignInfo);
        }
    }, [selectedDesignInfo]);

    const getDesignDetail = async (currentDesignInfo) => {
        const designDetailResult = await getSingleDesignById(currentDesignInfo?.id);
        setDesignDetail(designDetailResult);

        if (!currentDesignInfo?.parentId && designDetailResult?.parentId) {
            currentDesignInfo.parentId = designDetailResult?.parentId;
        }


        if (!currentDesignInfo?.parentId && designDetailResult?.parent) {
            const parentProductList = await searchParentProducts([{
                field: 'name',
                condition: '==',
                value: designDetailResult?.parent
            }]);

            currentDesignInfo.parentId = parentProductList[0]?.id;
        }

        if (currentDesignInfo?.parentId) {
            await getPinterestBoard(currentDesignInfo);
        }
    }

    const getPinterestBoard = async (currentDesignInfo) => {
        const exitingPinterestBoard = await getPinterestBoardForParentProduct(currentDesignInfo?.parentId);

        const existingPinterestBoardsByProductIdMap = {...pinterestBoardsByProductIdMap};
        existingPinterestBoardsByProductIdMap[currentDesignInfo?.parentId] = exitingPinterestBoard;
        setPinterestBoardsByProductIdMap(existingPinterestBoardsByProductIdMap);
        processPinterestBoard(currentDesignInfo, exitingPinterestBoard, existingPinterestBoardsByProductIdMap);
    }

    const processPinterestBoard = (currentDesignInfo, exitingPinterestBoard, existingPinterestBoardsByProductIdMap) => {
        let currentDesignList = [...designList];
        const designsByParentIdMap = _.groupBy(currentDesignList, 'parentId');
        const parentDesignsList = designsByParentIdMap[currentDesignInfo?.parentId];

        if (!exitingPinterestBoard) {
            exitingPinterestBoard = {
                parentId: currentDesignInfo?.parentId,
                name: currentDesignInfo?.parent,
                sections: []
            }
        }

        const quoteSections = exitingPinterestBoard?.quoteSections || {};
        _.forEach(parentDesignsList, (design) => {
            if (!quoteSections[design?.quoteId]) {
                exitingPinterestBoard?.sections.push({
                    name: prepareQuoteName(design?.quoteName),
                    quoteId: design?.quoteId
                });
            }
        });

        existingPinterestBoardsByProductIdMap[currentDesignInfo?.parentId] = exitingPinterestBoard;
        setPinterestBoardsByProductIdMap(existingPinterestBoardsByProductIdMap);

        setPinterestBoard(exitingPinterestBoard);
    }

    const prepareQuoteName = (quoteName) => {
        quoteName = quoteName?.replace('| Batch 01', '').trim();
        quoteName = quoteName?.replace('Batch 01', '').trim();
        return quoteName;
    }

    const getCurrentPinterestPinSync = async () => {
        const pinterestPinSyncResult = await getCurrentPinterestPinSyncByType('PINTEREST');
        setPinterestPinSync(pinterestPinSyncResult);
    }

    const getPinterestImages = async (currentDesignInfo) => {
        const searchCriteriaList = [{
            field: 'designId',
            condition: '==',
            value: currentDesignInfo?.id
        }];

        const pinterestImagesResult = await searchPinterestImagesWithSearchCriteria(searchCriteriaList);
        await prepareImageDownloadUrls(pinterestImagesResult);
        setPinterestImages(pinterestImagesResult);
    }

    const prepareImageDownloadUrls = async (pinterestImagesResult) => {
        await Promise.all(pinterestImagesResult.map(async (pinterestImage) => {
            await Promise.all(pinterestImage?.cards.map(async (card) => {
                if (!card.downloadUrl) {
                    const imageDetail: any = {
                        fullPath: pinterestImage?.imageBasePath + '/' + card?.cardName + '.png'
                    };

                    await getImageDownloadUrlFromFullPath(imageDetail);
                    card.downloadUrl = imageDetail?.downloadUrl;
                }

                const thumbImageDetail: any = {
                    fullPath: pinterestImage?.imageBasePath + '/thumb_' + card?.cardName + '.png'
                };

                await getImageDownloadUrlFromFullPath(thumbImageDetail);
                card.thumbnail = thumbImageDetail?.downloadUrl;
            }));
        }));
    }

    const markAsCompleted = async () => {
        setDataFetchInProgress(true);

        const currentPinterestPinSync = {...pinterestPinSync};
        currentPinterestPinSync.status = 'COMPLETED';

        await updateSinglePinterestPinSync(currentPinterestPinSync);
        await getCurrentPinterestPinSync();

        setDataFetchInProgress(false);
    }

    const triggerCreatePinterestBoard = async () => {
        setDataFetchInProgress(true);

        const pinterestBoardInput = {...pinterestBoard};
        const accessToken = pinterestAccount?.access.access_token;

        if (pinterestBoardInput?.id) {
            const sectionsInput: any = {};
            sectionsInput.accessToken = accessToken;
            sectionsInput.sections = pinterestBoardInput?.sections;
            sectionsInput.boardId = pinterestBoardInput?.id;
            await createPinterestSections(pinterestAccount?.id, sectionsInput);
        } else {
            pinterestBoardInput.accessToken = accessToken;
            await createPinterestBoardAndSections(pinterestAccount?.id, pinterestBoardInput);
        }

        await getPinterestBoard(selectedDesignInfo);
        setDataFetchInProgress(false);
    }

    const publishToPinterest = async (pinterestImage) => {
        setSyncUpdateInProgress(true);
        const existingDesignDetail = {...designDetail};
        const pinsList = prepareSingleDesignPinterestPinsList(existingDesignDetail, pinterestImage, pinterestBoard);

        if (pinsList) {
            const pinsInput: any = {};
            pinsInput.accessToken = pinterestAccount?.access?.access_token;
            pinsInput.pinsList = pinsList;
            pinsInput.parentId = existingDesignDetail?.parentId;
            pinsInput.designId = existingDesignDetail?.id;
            pinsInput.quoteId = existingDesignDetail?.quoteId;
            pinsInput.pinterestImageId = pinterestImage?.id;
            await createPinterestPins(pinterestAccount?.id, pinsInput);

            pinterestImage.added = true;
            await updateSinglePinterestImage(pinterestImage);
        }

        setSyncUpdateInProgress(false);
    }

    return (
        <>

            <div className="flex w-full justify-between items-center">

                <div className="flex w-fit justify-start items-center -ml-2">
                    <div className={'text-xl ml-2 w-48 flex'}>
                        Design Info
                        {filteredDesignList?.length > 0 &&
                            <span className={'ml-2'}>({filteredDesignList?.length})</span>
                        }
                    </div>

                    <div className={'w-full flex'}>
                        {allDesignInfo &&
                            <div className={'w-full flex justify-start items-start'}>
                                <DesignInfoFilters
                                    dataFetchInProgress={false}
                                    allDesignInfo={allDesignInfo}
                                    showSecondaryFilters={false}
                                    containerClass={''}
                                    allFilterFields={DESIGN_INFO_FILTER_FOR_SELECT_IMAGES_FIELDS}
                                    fieldClass={'w-fit'}
                                    filterCriteria={filterCriteria}
                                    setFilterCriteria={setFilterCriteria}/>
                            </div>
                        }

                        <div className="mx-2">
                            <ShowProgressSpinner dataFetchInProgress={dataFetchInProgress}/>
                        </div>
                    </div>
                </div>

            </div>

            <div className="flex justify-start mt-4">

                <div className="w-1/4">

                    <div
                        className={'table-container-with-title-2 bg-white overflow-y-scroll border border-gray-400 rounded-md'}>

                        <ShowEmptyListMessage
                            dataList={filteredDesignList}
                            dataFetchInProgress={dataFetchInProgress}
                            label={'Designs'}/>

                        {filteredDesignList?.length > 0 &&
                            <table className="w-full">
                                <thead className="">
                                <tr>
                                    <th className="p-2 border-y border-gray-400 bg-gray-400 text-white sticky top-0 w-8">S.No</th>
                                    <th className="p-2 border-y border-gray-400 bg-gray-400 text-white sticky top-0 text-left">Name</th>
                                </tr>
                                </thead>
                                <tbody className="">
                                {filteredDesignList?.map((designInfo, rowIndex) => (
                                    <tr key={`row-${rowIndex}`}
                                        onClick={() => {
                                            setSelectedDesignInfo(designInfo);
                                        }}
                                        className={`border-b border-gray-400 cursor-pointer hover:bg-green-100 ${(selectedDesignInfo && selectedDesignInfo?.id === designInfo?.id) ? 'bg-green-200' : ''}`}>
                                        <td className="p-2 m-auto">
                                            <div className="flex justify-center w-8">
                                                {rowIndex + 1}
                                            </div>
                                        </td>

                                        <td className={`p-2 m-auto flex justify-start items-center`}>
                                            <div className={'mr-4'}>
                                                {designInfo?.name}
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        }

                    </div>

                </div>

                <div className={'w-3/4'}>
                    <div className={'mx-4 mt-4'}>

                        <div className="flex justify-between items-center mb-4 ml-1">
                            {selectedDesignInfo &&
                                <div className="text-xl mt-1 mr-4">
                                    <div className="mr-1 text-purple-700 font-semibold">{selectedDesignInfo?.name}</div>
                                    <div className={'flex flex-wrap justify-start items-center'}>
                                        <div className="mr-1 font-semibold">{selectedDesignInfo?.productType}</div>
                                        |
                                        <div className="mx-1 font-semibold">{selectedDesignInfo?.category}</div>
                                    </div>
                                </div>
                            }

                            <div className={''}>
                                <AddEditPinterestImages
                                    isAddImageMedia={true}
                                    isEditImageMedia={false}
                                    isCopyImageMedia={false}
                                    designInfo={selectedDesignInfo}
                                    cssClass={'button-green px-2 py-1 flex items-center justify-center'}
                                    afterSaveAction={() => {
                                        getPinterestImages(selectedDesignInfo);
                                    }}/>
                            </div>

                            {pinterestPinSync &&
                                <div className={'flex justify-center items-center'}>
                                    <ExportBulkPinterestPins pinterestPinSync={pinterestPinSync}/>

                                    <div className={'mx-1'}>
                                        <button
                                            onClick={markAsCompleted}
                                            className={'button-red-outline px-2 py-1'}>
                                            Mark as Completed
                                        </button>
                                    </div>
                                </div>
                            }
                        </div>

                        {selectedDesignInfo &&
                            <div className={'border border-gray-100 bg-white rounded-md p-4 my-4'}>
                                <div
                                    className={' flex justify-between items-center border border-gray-200 bg-gray-100 rounded-md px-6 py-4'}>
                                    <div className={''}>
                                        <div className={'text-gray-600 font-semibold mb-3'}>Pinterest Board</div>
                                        <div
                                            className={'text-lg flex justify-start items-center rounded-md px-2 py-1 border font-semibold bg-sky-100 border-sky-200'}>
                                            {pinterestBoard?.id &&
                                                <div className="mr-1 text-green-600">
                                                    <CheckCircleIcon className="h-6 w-6"/>
                                                </div>
                                            }
                                            {!pinterestBoard?.id &&
                                                <div className="mr-1 text-sky-600">
                                                    <PlusCircleIcon className="h-6 w-6"/>
                                                </div>
                                            }
                                            {pinterestBoard?.name}
                                        </div>
                                    </div>
                                    <div className={'ml-8'}>
                                        <div className={'text-gray-600 font-semibold mb-3'}>Pinterest Sections</div>
                                        <div className={'flex flex-wrap justify-start items-center'}>
                                            {pinterestBoard?.sections?.map((section, index) => (
                                                <div key={`row-${index}`}
                                                     className={`mr-2 mb-2 text-lg flex justify-start items-center rounded-md px-2 py-1 border
                                                      ${section?.quoteId === selectedDesignInfo?.quoteId ? 'font-semibold bg-sky-100 border-sky-200' : 'bg-white border-gray-200'}`}>
                                                    {section?.id &&
                                                        <div className="mr-1 text-green-600">
                                                            <CheckCircleIcon className="h-6 w-6"/>
                                                        </div>
                                                    }
                                                    {!section?.id &&
                                                        <div className="mr-1 text-gray-600">
                                                            <PlusCircleIcon className="h-6 w-6"/>
                                                        </div>
                                                    }

                                                    <span>{section?.name}</span>
                                                </div>
                                            ))}
                                        </div>
                                    </div>

                                    <div className={'ml-4'}>
                                        <button
                                            onClick={triggerCreatePinterestBoard}
                                            className={'button-green-outline px-2 py-1'}>
                                            Create Pinterest Board & Sections
                                        </button>
                                    </div>
                                </div>

                                <ShowEmptyListMessage
                                    dataList={pinterestImages}
                                    dataFetchInProgress={dataFetchInProgress}
                                    label={'Pinterest Images'}/>

                                {pinterestImages?.length > 0 &&
                                    <div className={'mt-8'}>
                                        {pinterestImages?.map((pinterestImage, index) => (
                                            <div key={`pinterest-image-${index}`}>
                                                <div className="ml-2 mb-2 flex justify-start items-center">
                                                    <div className={'text-2xl'}># {index + 1}</div>
                                                    <div
                                                        className={'border border-gray-500 bg-gray-700 text-white text-lg rounded-full font-semibold px-3 py-1 ml-4'}>{pinterestImage?.cards?.length}</div>
                                                    {pinterestImage?.added &&
                                                        <div
                                                            className={'ml-4 border border-green-800 bg-green-50 text-green-800 rounded px-2 py-1'}>Published</div>
                                                    }

                                                    <div className={'ml-4'}>
                                                        <AddEditPinterestImages
                                                            isEditImageMedia={true}
                                                            designInfo={selectedDesignInfo}
                                                            designDetail={designDetail}
                                                            pinterestBoard={pinterestBoard}
                                                            pinterestAccount={pinterestAccount}
                                                            currentPinterestImage={pinterestImage}
                                                            cssClass={'button-green px-3 py-2 flex items-center justify-center'}
                                                            afterSaveAction={() => {
                                                                getPinterestImages(selectedDesignInfo);
                                                            }}/>
                                                    </div>

                                                    <div className={'ml-4'}>
                                                        <button
                                                            className={`px-3 py-1 mr-2 flex items-center justify-center ${pinterestImage?.added ? 'button-purple-outline' : 'button-purple'}`}
                                                            disabled={pinterestImage?.syncUpdateInProgress}
                                                            onClick={() => {
                                                                publishToPinterest(pinterestImage);
                                                            }}>
                                                            Publish to Pinterest

                                                            <span className="ml-1">
                                                                <ShowProgressSpinner
                                                                    sizeClass={'w-5 h-5'}
                                                                    dataFetchInProgress={syncUpdateInProgress}/>
                                                            </span>
                                                        </button>
                                                    </div>

                                                    {/*<div className={'ml-4'}>
                                                        <button
                                                            className="button-green px-4 py-2 mt-1 flex items-center justify-center"
                                                            onClick={() => {
                                                                addToPinterestPinSync(pinterestImage);
                                                            }}>
                                                            <span>Add To Pinterest Sync</span>
                                                            <span className="ml-1">
                                                                <ShowProgressSpinner
                                                                    sizeClass={'w-5 h-5'}
                                                                    dataFetchInProgress={syncUpdateInProgress}/>
                                                            </span>
                                                        </button>
                                                    </div>*/}
                                                </div>
                                                <div className="h-fit flex flex-wrap justify-start items-center">
                                                    {pinterestImage?.cards?.map((card, cardIndex) => (
                                                        <React.Fragment
                                                            key={cardIndex}>
                                                            <ProductImageSmall
                                                                dimension={75}
                                                                imageUrl={card?.thumbnail || card?.imageUrl}
                                                                afterImageSelected={() => {
                                                                    window.open(card?.downloadUrl || card?.imageUrl, '_blank');
                                                                }}/>
                                                        </React.Fragment>
                                                    ))}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                }
                            </div>
                        }

                    </div>
                </div>

            </div>

        </>
    )
}

export default DesignInfoList

